let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Usen")).then(() => parcelRequire('9Y9pf'));